export const LM_SP_URL = 'lemanapro.ru';
export const LM_CC_PHONE_LINK = 'tel:+78007000099';
export const LM_CC_PHONE = '8 800 700-00-99';
export const MOBILE_VIEW_SEARCH_PARAM = 'mobile-view';
export const photoUrlBase = 'https://cdn.lemanapro.ru/lmru/image/upload/site';
export const cdnPhotoUrl =
	'https://cdn.lemanapro.ru/lmru/image/upload/v1789133276/fudzi/services-platform/services-landings';
